<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container"  *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
    <app-documents-panel-list #docPanel 
    [showLoader]="showLoader" 
    [documentSearchResult]=documentSearchResult   
    (checkboxSelection)="getPanelListData()"
    [myPanelListType]="PanelListType"
    [defaultFiltersSelected] = defaultFiltersSelected></app-documents-panel-list>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>